/**
 * Created by Jerker Nord on 2021-01-27.
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class ElGordosRevengeGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "NumbersWinCountUp";
    static BITMAP_FONT_WAYS = "NumbersWays";
    static BITMAP_FONT_NUDGE_MULTIPLIER = "NumbersWays";
    static BITMAP_FONT_FREESPIN_NUMBER = "Freespins_numbers";
    static BITMAP_FONT_FREESPIN_INTRO_NUMBER = "FS_intro_numbers";

    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_BACKGROUND:string = "freespinBackground";

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [],

        main : [
            {
                name : "fonts",
                assets : [
                    new BitmapFontAsset(ElGordosRevengeGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(ElGordosRevengeGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(ElGordosRevengeGameAssets.BITMAP_FONT_WAYS, "fonts/bitmapfonts/NumbersWays.fnt"),
                    new BitmapFontAsset(ElGordosRevengeGameAssets.BITMAP_FONT_FREESPIN_NUMBER, "fonts/bitmapfonts/Freespins_numbers.fnt"),
                    new BitmapFontAsset(ElGordosRevengeGameAssets.BITMAP_FONT_FREESPIN_INTRO_NUMBER, "fonts/bitmapfonts/FS_intro_numbers.fnt")
                ]
            },
            {
                name : "backgrounds",
                assets : [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                    new TextureAsset("backgroundsJpeg2", "sheets/backgroundsJpeg/backgroundsJpeg2.json")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    // new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    // new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainNoCompress0", "sheets/mainnocompress/main0.json")
                ]
            },
            {
                name : "mainHigh",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainHigh0", "sheets/main/mainHigh0.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbolsnocompress0", "sheets/symbolsnocompress/symbols0.json"),
                    new TextureAsset("symbolsJpeg0", "sheets/symbolsJpeg/symbolsJpeg0.json")
                ],
                animations : {}
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("bg_NORMAL", "spine/BG.json"),
                    new SpineAsset("bg_FREESPIN", "spine/BG_FS.json"),
                    new SpineAsset("bg_FREESPIN_SUPER", "spine/BG_SFS.json"),
                    new SpineAsset("shootVFX", "spine/shootVFX.json"),
                    new SpineAsset("cylinder", "spine/cylinder.json"),
                    new SpineAsset("cylinderVFX", "spine/cylinderVFX.json"),
                    new SpineAsset("cylinderLogos", "spine/cylinder_Logos.json"),
                    new SpineAsset("S1", "spine/S1.json"),
                    new SpineAsset("S1Win", "spine/S1_Blast.json"),
                    new SpineAsset("S2", "spine/S2.json"),
                    new SpineAsset("S2Win", "spine/S2_blast.json"),
                    new SpineAsset("WRS", "spine/WRS.json"),
                    new SpineAsset("WXN", "spine/WXN.json"),
                    new SpineAsset("BN", "spine/BN.json"),
                    new SpineAsset("L", "spine/L.json"),
                    new SpineAsset("M1", "spine/M1.json"),
                    new SpineAsset("M2", "spine/M2.json"),
                    new SpineAsset("M3", "spine/M3.json"),
                    new SpineAsset("M4", "spine/M4.json"),
                    new SpineAsset("M5", "spine/M5.json"),
                    new SpineAsset("Wild", "spine/S2_WildFire.json"),
                    new SpineAsset("xRIP", "spine/xRIP.json"),
                    new SpineAsset("split", "spine/splitReel.json"),
                    new SpineAsset("anticipation", "spine/FS_Anticipation.json"),
                    new SpineAsset("meterFire", "spine/meter_Fire.json"),
                    new SpineAsset("meterSkullFire", "spine/skull_fire.json"),
                    new SpineAsset("meterGlow", "spine/meter_glow.json"),
                    new SpineAsset("bw", "spine/big_wins.json"),
                    new SpineAsset("bwEffect", "spine/bwEffect.json"),
                    new SpineAsset("capWin", "spine/Cap_win.json"),
                    new SpineAsset("midExpend", "spine/MidExpend_Transition.json"),
                    new SpineAsset("fsIntro", "spine/FS_Intro.json"),
                    new SpineAsset("sfsIntro", "spine/SFS_Intro.json"),
                    new SpineAsset("fsOutro", "spine/FS_Outro.json"),
                    new SpineAsset("sfsOutro", "spine/SFS_Outro.json"),
                    new SpineAsset("meterOutro", "spine/meter_intros.json"),
                    new SpineAsset("xBetFrame", "spine/xbetVFX.json")
                ]
            }
        ]
    };
}
